import React, { FC } from "react"

const CloseIcon: FC<any> = ({ ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9226 2.07757C13.5971 1.75214 13.0695 1.75214 12.7441 2.07757L7.99999 6.82165L3.25592 2.07757L3.18825 2.01683C2.86103 1.75358 2.38115 1.77383 2.07741 2.07757C1.75197 2.40301 1.75197 2.93065 2.07741 3.25609L6.82148 8.00016L2.07741 12.7442L2.01666 12.8119C1.75342 13.1391 1.77366 13.619 2.07741 13.9228C2.40284 14.2482 2.93048 14.2482 3.25592 13.9228L7.99999 9.17867L12.7441 13.9228L12.8117 13.9835C13.139 14.2467 13.6188 14.2265 13.9226 13.9228C14.248 13.5973 14.248 13.0697 13.9226 12.7442L9.17851 8.00016L13.9226 3.25609L13.9833 3.18842C14.2466 2.8612 14.2263 2.38131 13.9226 2.07757Z"
        fill="#545E78"
      />
    </svg>
  )
}

export default CloseIcon
